<template>
  <div class="footer" :style="dx == 1 ? 'padding-bottom:22px' : 'padding-bottom:0px'">
    <div class="footer-item"  v-for='(item,index) of items' :class='[ {on:index === idx} ]' @click="tz(item.push)">
      <img :src="index === idx ? item.imgActive : item.imgUrl"/>
      <div>{{item.name}}</div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
	export default {
    data() {
      return {
        items: [
          {
            name: "首页",
            imgUrl:require('../../assets/images/home.png'),
            imgActive:require('../../assets/images/home-active.png'),
            push: "/main/index"
          },
          {
            name: "景点",
            imgUrl:require('../../assets/images/hb.png'),
            imgActive:require('../../assets/images/hb-active.png'),
            push: "/main/scenic"
          },
          {
            name: "电影票",
            imgUrl:require('../../assets/images/movies.png'),
            imgActive:require('../../assets/images/movies.png'),
            push: "/main/movies"
          },
          {
            name: "商圈",
            imgUrl:require('../../assets/images/product.png'),
            imgActive:require('../../assets/images/product-active.png'),
            push: "/main/product"
          },
          {
            name: "我的",
            imgUrl:require('../../assets/images/me.png'),
            imgActive:require('../../assets/images/me-active.png'),
            push: "/main/mine"
          }
        ]
      }
    },
    methods: {
      tz:function(url){
        location.href = url
      },
    },
    props: ['idx','dx']
	}
</script>

<style>
  .footer,.footers{
    display: flex;
    width: 100%;
    height: 48px;
    background:#fff;
    position:fixed;
    bottom:0;
    border-top:solid 1px rgba(102,102,102,0.1);
    left:0;
  }
  .footer .footer-item,.footers .footer-item{
    flex: 1;
    text-align: center;
    font-size: 13px;
    color: #555;
    padding-top:2px;
    font-weight:bold
  }
  .footer .footer-item img,.footers .footer-item img{
    display:block;
    width:26px;
    margin:0 auto;
  }
  .footer .footer-item:nth-child(3) div,.footers .footer-item:nth-child(2) div{
    padding-top:25.5px
  }
  .footer .footer-item:nth-child(3) img{
    border-radius: 50%;
    width:35px;
    position:absolute;
    background:#fff;
    padding:2px;
    left:50%;
    transform: translateX(-50%);
    top:-10px
  }
  .footers .footer-item:nth-child(2) img{
    border-radius: 50%;
    width:48px;
    position:absolute;
    left:50%;
    transform: translateX(-50%);
    top:-20px;
  }
  .footer .on{
    color:#2c2c2c
  }
</style>
